module.exports = __webpack_public_path__ + "img/logo-12.0342a30a.png";